import React from "react";
import clsx from "clsx";

import { ReactComponent as IconGoodOn } from "../../../../assets/images/AnswerList/icon_good_on.svg";
import { ReactComponent as IconGoodOff } from "../../../../assets/images/AnswerList/icon_good_off.svg";
import { ReactComponent as IconCommentOn } from "../../../../assets/images/AnswerList/icon_comment_on.svg";
import { ReactComponent as IconCommentOff } from "../../../../assets/images/AnswerList/icon_comment_off.svg";
import FormReply from "../../../../organisms/student/FormReply";
import { IAnswerN } from "../../../../state";

import styles from "./IssueList.module.scss";

type Props = {
  answer: IAnswerN;
  calling: boolean;
  currentStudentId: number;
  handleComment: (
    answerId: number,
    content: string,
    commentId?: number,
  ) => void;
  handleDeleteComment: (answerId: number, commentId: number) => void;
};

const AnswerBlock: React.FC<Props> = ({
  answer,
  calling,
  currentStudentId,
  handleComment,
  handleDeleteComment,
}) => {
  const [isCommentOpen, setIsCommentOpen] = React.useState(false);
  const hasComments = answer.comment_num > 0;
  const handleCommentClick = hasComments
    ? () => setIsCommentOpen(prev => !prev)
    : undefined;

  return (
    <div className={styles.answerBlock}>
      {answer.contents?.map(content => (
        <div key={content.question_id} className={styles.qaItem}>
          <div className={styles.question}>{content.statement}</div>
          <div className={styles.answer}>{content.content}</div>
        </div>
      ))}
      <div className={styles.reactionDivider} />
      <div className={styles.reactionArea}>
        <div className={styles.reactionRow}>
          <div className={styles.reactionItem}>
            {answer.is_like ? (
              <IconGoodOn className={styles.reactionIcon} />
            ) : (
              <IconGoodOff className={styles.reactionIcon} />
            )}
            <span>{answer.like_num}</span>
          </div>
          <div
            className={clsx(
              styles.reactionItem,
              hasComments && styles.reactionItemActive,
            )}
            onClick={handleCommentClick}
          >
            {hasComments ? (
              <IconCommentOn className={styles.reactionIcon} />
            ) : (
              <IconCommentOff className={styles.reactionIcon} />
            )}
            <span>{answer.comment_num}</span>
          </div>
        </div>
        {isCommentOpen && hasComments && (
          <div className={styles.commentList}>
            {answer.comments?.map(comment => (
              <FormReply
                key={comment.id}
                className={styles.formReplyItem}
                iconWrapperClassName={styles.formReplyIconWrapper}
                comment={comment}
                answerId={answer.id}
                name_opened={true}
                calling={calling}
                currentStudentId={currentStudentId}
                disableCancelConfirm={true}
                onSendComment={(text, answerId, commentId) =>
                  handleComment(answerId, text, commentId)
                }
                onDeleteReply={handleDeleteComment}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AnswerBlock;
